import { TextField } from '@mui/material';
import DateTimePicker from 'src/components/DateTimePicker';
import Select from 'src/components/Select/Select';
import Switch from 'src/components/Switch/Switch';

import { SxProps } from 'src/theme/types/sxProps';

const inputStyle: SxProps = { width: ({ spacing }) => spacing(42) };

const getOptions = (options) =>
  options.map((value) => ({
    value: value.enumValue,
    label: value.name,
  }));

export const solutionEditTwinFormFields = (
  displayData2,
  formData,
  handleChange
) => {
  const data = 'wer';
  return displayData2.flatMap((field) => {
    const handleFieldChange = (name, event) => {
      if (field.schema === 'boolean') {
        handleChange(name, event.target.checked);
      } else if (field.schema === 'dateTime') {
        handleChange(name, event);
      } else if (
        field.schema === 'integer' ||
        field.schema === 'number' ||
        field.schema === 'double' ||
        field.schema === 'float'
      ) {
        handleChange(name, Number(event.target.value));
      } else {
        handleChange(name, event.target.value);
      }
    };

    if (!field.schema) return [];

    if (field.schema === 'string') {
      return [
        {
          name: field.key,
          label: field.key,
          value: formData[field.name],
          Component: TextField,
          onChange: (event) => handleFieldChange(field.name, event),
          sx: inputStyle,
        },
      ];
    }

    if (
      field.schema === 'integer' ||
      field.schema === 'number' ||
      field.schema === 'double' ||
      field.schema === 'float'
    ) {
      return [
        {
          name: field.key,
          label: field.key,
          value: formData[field.name],
          Component: TextField,
          type: 'number',
          onChange: (event) => handleFieldChange(field.name, event),
          sx: inputStyle,
        },
      ];
    }

    if (field.schema === 'boolean') {
      return [
        {
          name: field.key,
          label: field.key,
          value: formData[field.name] || false,
          Component: Switch,
          type: 'checkbox',
          onChange: (event) => handleFieldChange(field.name, event),
        },
      ];
    }

    if (field.schema?.['@type'] === 'Enum' && field.schema?.enumValues) {
      return [
        {
          name: field.key,
          label: field.key,
          value: formData[field.name],
          Component: Select,
          options: getOptions(field.schema?.enumValues),
          onChange: (event) => handleFieldChange(field.name, event),
          sx: inputStyle,
        },
      ];
    }

    if (field?.schema === 'dateTime') {
      return [
        {
          name: field.key,
          label: field.key,
          placeholder: 'mm/dd/yyyy hh:mm',
          value: formData[field.name],
          Component: DateTimePicker,
          onChange: (value) => handleFieldChange(field.name, value),
          sx: inputStyle,
        },
      ];
    }

    return [];
  });
};
